import { TimelineBlock, TimelineVariant } from './timeline-block';
import { resolveStrapiMediaUrl } from '../../../core/utils/strapi-media.util';
import { renderRichText } from '../../../core/utils/render-rich-text.util';

export function adaptTimelineBlock(
  entry: Record<string, unknown>,
  baseUrl: string,
): Record<string, unknown> {
  const rawBlocks = entry['blocks'];
  const blocks: TimelineBlock[] = Array.isArray(rawBlocks)
    ? rawBlocks.map((b: Record<string, unknown>) => {
        const img = b['imageSrc'] as Record<string, unknown> | null;
        return {
          overline: (b['overline'] as string) ?? undefined,
          heading: (b['heading'] as string) ?? '',
          body: renderRichText((b['body'] as string) ?? ''),
          imageSrc: img ? resolveStrapiMediaUrl(baseUrl, (img['url'] as string) ?? null) ?? undefined : undefined,
          imageAlt: (img?.['alternativeText'] as string) ?? undefined,
          imageWidth: img ? (img['width'] as number) ?? 0 : 0,
          imageHeight: img ? (img['height'] as number) ?? 0 : 0,
        };
      })
    : [];

  return {
    variant: (entry['variant'] as TimelineVariant) ?? 'detection',
    blocks,
  };
}
